import { RefObject } from "react"
import { ParticipantAdminDto } from "../../types/contracts"

const DownloadQRCode = (
  qrCodeRef: RefObject<HTMLDivElement>,
  selectedParticipant: ParticipantAdminDto | null
) => {
  if (qrCodeRef.current && selectedParticipant) {
    const svgElement = qrCodeRef.current.querySelector("svg");
    if (svgElement) {
      // Serialize the QR code SVG to use it on the canvas
      const svgData = new XMLSerializer().serializeToString(svgElement);
      const svgBlob = new Blob([svgData], {
        type: "image/svg+xml;charset=utf-8",
      });
      const url = URL.createObjectURL(svgBlob);

      // Create a new Image object for the QR code
      const qrImage = new Image();
      qrImage.src = url;

      // When the QR code image loads, draw it on the canvas
      qrImage.onload = () => {
        // Create a canvas to draw the QR code and participant info
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        if (ctx) {
          // Set canvas dimensions
          canvas.width = 600;
          canvas.height = 800;

          // Fill canvas with white background
          ctx.fillStyle = "white";
          ctx.fillRect(0, 0, canvas.width, canvas.height);

          // Draw QR code on the canvas
          ctx.drawImage(qrImage, 150, 50, 300, 300);

          // Add participant information to the canvas
          ctx.font = "20px Arial bold";
          ctx.fillStyle = "black";
          ctx.fillText(`Jméno: ${selectedParticipant.name}`, 50, 400);
          ctx.fillText(`Adresa: ${selectedParticipant.address}`, 50, 450);
          if (selectedParticipant.dateOfBirth) {
            ctx.fillText(
              `Datum narození: ${selectedParticipant.dateOfBirth}`,
              50,
              500
            );
          }
          ctx.fillText(`Email: ${selectedParticipant.email}`, 50, 550);
          if (selectedParticipant.phoneNumber) {
            ctx.fillText(
              `Tel. číslo: ${selectedParticipant.phoneNumber}`,
              50,
              600
            );
          }
          ctx.fillText(
            `Druh členství: ${selectedParticipant.feeTypeName}`,
            50,
            650
          );
          if (selectedParticipant.organizationName) {
            ctx.fillText(
              `Organizace: ${selectedParticipant.organizationName}`,
              50,
              700
            );
          }

          // Create a link to download the canvas as an image
          const link = document.createElement("a");
          link.href = canvas.toDataURL("image/png");
          link.download = `${selectedParticipant.name}_ID_KCT_Card.png`;
          link.click();
        }

        // Release the object URL after the QR image has been loaded
        URL.revokeObjectURL(url);
      };
    }
  }
};

export default DownloadQRCode;
